import { reducerWithInitialState } from "typescript-fsa-reducers";

import { CompanyValue, EntitiesMap } from "../entities";
import { EntityValidationResultMap, EntityValidationMapError } from "../../lib/entities/validation";

import {
  bootstrapCompanyShow,
  loadCompanyShow,
  draftCompanyValuesUpdated,
  saveDraftCompanyValues,
  loadSimilarCompanies,
  loadInvisibleCompanyValues,
  draftReset,
} from "../actions";
import { CompanyShowResponse } from "../api";

export interface ShowState {
  companyMembershipSectionIds: EntityId[];
  projectIds: EntityId[];
  portfolioProjectIds: EntityId[];
  companyValues: EntityId[];
  similarCompanyIds: EntityId[];
  isLoaded: boolean;
  draftCompanyValues: CompanyValue[];
  draftCompanyValueErrors: EntityValidationResultMap<CompanyValue>;
  isDraftCompanyValuesDirty: boolean;
}

const InitialState: ShowState = {
  companyMembershipSectionIds: [],
  projectIds: [],
  portfolioProjectIds: [],
  companyValues: [],
  similarCompanyIds: [],
  isLoaded: false,
  draftCompanyValues: [],
  draftCompanyValueErrors: {},
  isDraftCompanyValuesDirty: false,
};

function initState(state: ShowState, { result, entities }: CompanyShowResponse): ShowState {
  return {
    ...state,
    companyMembershipSectionIds: result.company_membership_sections,
    projectIds: result.projects,
    portfolioProjectIds: result.portfolio_projects,
    companyValues: result.company_values,
    isLoaded: true,
    isDraftCompanyValuesDirty: false,
    ...updateDraftCompanyValues(result.company_values, entities),
  };
}

function updateDraftCompanyValues(ids: EntityId[], entities: EntitiesMap) {
  const draftCompanyValues = ids.map(id => entities.company_values[id]!);
  const draftCompanyValueErrors: EntityValidationResultMap<CompanyValue> = {};
  return { draftCompanyValues, draftCompanyValueErrors };
}

const showReducer = reducerWithInitialState<ShowState>(InitialState)
  .case(bootstrapCompanyShow, initState)
  .case(loadCompanyShow.done, (state, { result: actionRes }) => {
    return initState(state, actionRes);
  })
  .case(draftReset, (state, entities) => {
    return { ...state, ...updateDraftCompanyValues(state.companyValues, entities), isDraftCompanyValuesDirty: false };
  })
  .case(draftCompanyValuesUpdated, (state, { companyValues }) => {
    return {
      ...state,
      draftCompanyValues: companyValues,
      isDraftCompanyValuesDirty: true,
    };
  })
  .case(loadInvisibleCompanyValues.done, (state, { result: { result, entities } }) => {
    return {
      ...state,
      ...updateDraftCompanyValues(result, entities),
    };
  })
  .case(saveDraftCompanyValues.done, (state, { result: { result, entities } }) => {
    return {
      ...state,
      isDraftCompanyValuesDirty: false,
      ...updateDraftCompanyValues(result, entities),
    };
  })
  .case(saveDraftCompanyValues.failed, (state, { error }) => {
    if (error instanceof EntityValidationMapError) {
      return { ...state, draftCompanyValueErrors: error.getResult() };
    }
    return state;
  })
  .case(loadSimilarCompanies.done, (state, { result }) => {
    return { ...state, similarCompanyIds: result.result };
  });

export default showReducer;



// WEBPACK FOOTER //
// ./frontend/src/companies/reducers/show.ts